// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2-fwN","flickity-prev-next-button":"style_flickity-prev-next-button__237tg","arrow":"style_arrow__oQqbZ"};